import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const fadeUp = {
    hidden: { opacity: 0, y: 36 },
    show: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.8, delay: i * 0.09, ease: EASE },
    }),
};

export const Reveal = ({ children, className, delay = 0, ...props }) => (
    <motion.div
        className={className}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
        variants={fadeUp}
        custom={delay}
        {...props}
    >
        {children}
    </motion.div>
);
